/**
 * @class Apps
 * @param element HTMLElement
 * @constructor
 */
function Apps(element){
	this._element = element;
	this._mouseHandlerBound = this._mouseHandler.bind(this);

	var numApps;
	var apps;
	var appElement;
	var decorationElement;
	var numDecorations = 0;
	this._decoratedAppElements = [];
	this._decorations = [];
	// Object VR
	if(numApps = (apps = element.getElementsByClassName("apps_app")).length){
		for(var index = 0; index < numApps; index++){
			appElement = apps[index];
			decorationElement = appElement.getElementsByClassName("apps_app-decoration")[0];
			if(decorationElement){
				appElement.addEventListener("mouseenter", this._mouseHandlerBound, false);
				appElement.addEventListener("mouseleave", this._mouseHandlerBound, false);
				this._decoratedAppElements[numDecorations] = appElement;
				this._decorations[numDecorations] = new AppDecorationIFrame(decorationElement);
				numDecorations++;
			}

		}
	}
}

/** @type HTMLElement */
Apps.prototype._element = null;
/** @type {Array.<HTMLElement>} */
Apps.prototype._decoratedAppElements = null;
/** @type Function */
Apps.prototype._mouseHandlerBound = null;
/** @type Array.<AppDecorationIFrame> */
Apps.prototype._decorations = null;

Apps.prototype._mouseHandler = function _mouseHandler(event){
	var index = this._decoratedAppElements.indexOf(event.currentTarget);
	if(index >= 0){
		this._decorations[index].state = event.type == "mouseenter" ? "target" : "untarget";
	}
};

Apps.prototype.clear = function clear(){
	for(var index = 0, numApps = this._decoratedAppElements.length; index < numApps; index++){
		var appElement = this._decoratedAppElements[index];
		appElement.removeEventListener("mouseenter", this._mouseHandlerBound, false);
		appElement.removeEventListener("mouseleave", this._mouseHandlerBound, false);
		this._decorations[index].clear();
	}

	return true;
};